import styled from "styled-components"

export const PackageRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`
export const PackageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 250px;
    min-width: 250px;
    margin: 8px 8px;
    padding: 12px;
    border-radius: 2px;
    background: ${(props) => props.theme.availablePackageBackground};
`
export const PackageName = styled.div`
    width: 100%;
    text-align: center;
    font-size: 15px;
    font-family: ${(props) => props.theme.openSans};
    text-transform: uppercase;
    margin-bottom: 20px;
    
    &::after {
        content: "";
        display: block;
        height: 1px;
        width: 100%;
        margin-top: 10px;
        background: ${(props) => props.theme.availablePackageNameAfter};
    }
`
export const PackageRowDescription = styled.div`
    font-size: 18px;
`
export const PackageButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: end;
`
export const PackageBuyButton = styled.div`
    // TODO: temporarily disabled
    pointer-events: none;
    opacity: 0.6;

    height: 38px;
    width: 100%;
    line-height: 36px;
    text-align: center;
    padding: 0 15px;
    margin-top: 10px;
    border-radius: 2px;
    white-space: nowrap;
    font-size: 15px;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
    text-transform: uppercase;
    user-select: none;
    cursor: pointer;
    background: ${(props) => props.theme.availablePackageButtonBackground};
`
